export default {
      id: "pin-usage",
      viewBox: "0 0 26 34",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#pin",
      toString: function () {
        return this.url;
      }
    }